export const ChevronUp = () => (
  <path
    d='M8.15009 15.0012L12.0301 11.1212L15.9101 15.0012C16.1014 15.165 16.3475 15.2506 16.5991 15.2409C16.8508 15.2312 17.0896 15.1268 17.2677 14.9487C17.4457 14.7706 17.5501 14.5319 17.5598 14.2802C17.5695 14.0286 17.4839 13.7825 17.3201 13.5912L12.7301 9.00118C12.5427 8.81493 12.2893 8.71039 12.0251 8.71039C11.7609 8.71039 11.5075 8.81493 11.3201 9.00118L6.73009 13.5912C6.54384 13.7785 6.4393 14.032 6.4393 14.2962C6.4393 14.5604 6.54384 14.8138 6.73009 15.0012C6.92002 15.1864 7.17481 15.29 7.44009 15.29C7.70537 15.29 7.96015 15.1864 8.15009 15.0012Z'
    fill='currentColor'
  />
)
